let measureContext: CanvasRenderingContext2D | null | undefined;

/** Measures rendered text width in pixels for the given CSS font shorthand. Returns 0 outside a browser. */
export const measureTextWidth = (text: string, font: string): number => {
  if (measureContext === undefined) {
    measureContext = document.createElement("canvas").getContext("2d");
  }

  if (!measureContext) {
    return 0;
  }

  measureContext.font = font;

  return measureContext.measureText(text).width;
};
